/* eslint-disable ember/no-component-lifecycle-hooks */
import { set } from '@ember/object';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ModalDialog from 'ember-modal-dialog/components/modal-dialog';

const BODY_CLASSES = ['overflow-hidden'];
const FIXED_BODY_CLASSES = ['fixed', 'w-full'];
// Phone full-bleed sizing lives in `_modals.scss` behind this class.
const RESPONSIVE_CLASS = 'ember-modal-dialog--responsive';
// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
export default ModalDialog.extend({
  /** Full-bleed on phone, with each caller's own desktop variant untouched. */
  responsive: false,

  didReceiveAttrs() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this._super(...arguments);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!this.responsive) return;
    // Append: callers pass their own `containerClassNames`.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const current: unknown = this.containerClassNames;
    const existing = (Array.isArray(current) ? current.join(' ') : (current as string) ?? '').trim();
    if (existing.split(/\s+/).includes(RESPONSIVE_CLASS)) return;
    set(this, 'containerClassNames', existing ? `${existing} ${RESPONSIVE_CLASS}` : RESPONSIVE_CLASS);
  },

  didInsertElement() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this._super(...arguments);
    const hasScrollBar = window.innerWidth > document.body.clientWidth;
    if (hasScrollBar) {
      document.body.style.marginRight = `${window.innerWidth - document.body.clientWidth}px`;
    }
    document.body.classList.add(...BODY_CLASSES);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.fixedBody) document.body.classList.add(...FIXED_BODY_CLASSES);
  },
  willDestroyElement() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this._super(...arguments);
    document.body.classList.remove(...BODY_CLASSES);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.fixedBody) document.body.classList.remove(...FIXED_BODY_CLASSES);
    document.body.style.marginRight = '';
  },
});
